import { render, staticRenderFns } from "./ModalSelectBroadcast.vue?vue&type=template&id=2d560ba6&"
import script from "./ModalSelectBroadcast.vue?vue&type=script&lang=js&"
export * from "./ModalSelectBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./ModalSelectBroadcast.vue?vue&type=style&index=0&id=2d560ba6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports